<template>
  <div
    class="mc-liveview__map"
    :class="{
      'close-history': $store.state.map.modalFleetHistory === true,
      '':
        $store.state.map.modalFleetHistory === false,
    }"
  >
    <RightButton />
    <GmapFleet v-if="$store.state.map.type === 'fleet'" :temporary-live-view="temporaryLiveView" />
    <GmapHistory v-else-if="$store.state.map.type === 'history'" />
  </div>
</template>

<script>
import RightButton from "./RightButton";
import GmapFleet from "./GoogleMap/GmapFleet";

export default {
  name: "GoogleMap",
  components: {
    RightButton,
    GmapFleet,
  },
  props: {
    temporaryLiveView: {
      type: Object,
      default: null,
    },
  },
};
</script>
